<template>
  <v-row class="text-center" justify="space-around" height='90vh' style="margin: 0 0">
    <v-col cols="6" v-if='level == 0'>
      <table>
          <tr>
            <v-hover v-for="index in 4" v-slot:default='{ hover }'>
              <td style="height: 8rem; width: 6rem;" @click="select(deck[index - 1])">
                <v-img :src="selected.includes(deck[index - 1]) || matched.includes(deck[index - 1].uId) ? deck[index - 1].image : 'https://i.imgur.com/xV7k72g.jpg'" width="6rem" height="8rem" :class="[matched.includes(deck[index - 1].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 4" v-slot:default='{ hover }'>
              <td style="height: 8rem; width: 6rem;" @click="select(deck[index + 3])">
                <v-img :src="selected.includes(deck[index + 3]) || matched.includes(deck[index + 3].uId) ? deck[index + 3].image : 'https://i.imgur.com/xV7k72g.jpg'" width="6rem" height="8rem" :class="[matched.includes(deck[index + 3].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 4" v-slot:default='{ hover }'>
              <td style="height: 8rem; width: 6rem;" @click="select(deck[index + 7])">
                <v-img :src="selected.includes(deck[index + 7]) || matched.includes(deck[index + 7].uId) ? deck[index + 7].image : 'https://i.imgur.com/xV7k72g.jpg'" width="6rem" height="8rem" :class="[matched.includes(deck[index + 7].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
        </table>
    </v-col>
    <v-col cols="6" v-if='level == 1'>
      <table>
          <tr>
            <v-hover v-for="index in 6" v-slot:default='{ hover }'>
              <td style="height: 8rem; width: 6rem;" @click="select(deck[index - 1])">
                <v-img :src="selected.includes(deck[index - 1]) || matched.includes(deck[index - 1].uId) ? deck[index - 1].image : 'https://i.imgur.com/xV7k72g.jpg'" width="6rem" height="8rem" :class="[matched.includes(deck[index - 1].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 6" v-slot:default='{ hover }'>
              <td style="height: 8rem; width: 6rem;" @click="select(deck[index + 5])">
                <v-img :src="selected.includes(deck[index + 5]) || matched.includes(deck[index + 5].uId) ? deck[index + 5].image : 'https://i.imgur.com/xV7k72g.jpg'" width="6rem" height="8rem" :class="[matched.includes(deck[index + 5].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 6" v-slot:default='{ hover }'>
              <td style="height: 8rem; width: 6rem;" @click="select(deck[index + 11])">
                <v-img :src="selected.includes(deck[index + 11]) || matched.includes(deck[index + 11].uId) ? deck[index + 11].image : 'https://i.imgur.com/xV7k72g.jpg'" width="6rem" height="8rem" :class="[matched.includes(deck[index + 11].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 6" v-slot:default='{ hover }'>
              <td style="height: 8rem; width: 6rem;" @click="select(deck[index + 17])">
                <v-img :src="selected.includes(deck[index + 17]) || matched.includes(deck[index + 17].uId) ? deck[index + 17].image : 'https://i.imgur.com/xV7k72g.jpg'" width="6rem" height="8rem" :class="[matched.includes(deck[index + 17].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
        </table>
    </v-col>
    <v-col cols="6" v-if='level == 2'>
      <table>
          <tr>
            <v-hover v-for="index in 8" v-slot:default='{ hover }'>
              <td style="height: 6rem; width: 4rem;" @click="select(deck[index - 1])">
                <v-img :src="selected.includes(deck[index - 1]) || matched.includes(deck[index - 1].uId) ? deck[index - 1].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="6rem" :class="[matched.includes(deck[index - 1].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 8" v-slot:default='{ hover }'>
              <td style="height: 6rem; width: 4rem;" @click="select(deck[index + 7])">
                <v-img :src="selected.includes(deck[index + 7]) || matched.includes(deck[index + 7].uId) ? deck[index + 7].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="6rem" :class="[matched.includes(deck[index + 7].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 8" v-slot:default='{ hover }'>
              <td style="height: 6rem; width: 4rem;" @click="select(deck[index + 15])">
                <v-img :src="selected.includes(deck[index + 15]) || matched.includes(deck[index + 15].uId) ? deck[index + 15].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="6rem" :class="[matched.includes(deck[index + 15].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 8" v-slot:default='{ hover }'>
              <td style="height: 6rem; width: 4rem;" @click="select(deck[index + 23])">
                <v-img :src="selected.includes(deck[index + 23]) || matched.includes(deck[index + 23].uId) ? deck[index + 23].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="6rem" :class="[matched.includes(deck[index + 23].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 8" v-slot:default='{ hover }'>
              <td style="height: 6rem; width: 4rem;" @click="select(deck[index + 31])">
                <v-img :src="selected.includes(deck[index + 31]) || matched.includes(deck[index + 31].uId) ? deck[index + 31].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="6rem" :class="[matched.includes(deck[index + 31].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 8" v-slot:default='{ hover }'>
              <td style="height: 6rem; width: 4rem;" @click="select(deck[index + 39])">
                <v-img :src="selected.includes(deck[index + 39]) || matched.includes(deck[index + 39].uId) ? deck[index + 39].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="6rem" :class="[matched.includes(deck[index + 39].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
        </table>
    </v-col>
    <v-col cols="6" v-if='level == 3'>
      <table>
          <tr>
            <v-hover v-for="index in 9" v-slot:default='{ hover }'>
              <td style="height: 4.5rem; width: 4rem;" @click="select(deck[index - 1])">
                <v-img :src="selected.includes(deck[index - 1]) || matched.includes(deck[index - 1].uId) ? deck[index - 1].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="4.5rem" :class="[matched.includes(deck[index - 1].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 9" v-slot:default='{ hover }'>
              <td style="height: 4.5rem; width: 4rem;" @click="select(deck[index + 8])">
                <v-img :src="selected.includes(deck[index + 8]) || matched.includes(deck[index + 8].uId) ? deck[index + 8].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="4.5rem" :class="[matched.includes(deck[index + 8].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 9" v-slot:default='{ hover }'>
              <td style="height: 4.5rem; width: 4rem;" @click="select(deck[index + 17])">
                <v-img :src="selected.includes(deck[index + 17]) || matched.includes(deck[index + 17].uId) ? deck[index + 17].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="4.5rem" :class="[matched.includes(deck[index + 17].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 9" v-slot:default='{ hover }'>
              <td style="height: 4.5rem; width: 4rem;" @click="select(deck[index + 26])">
                <v-img :src="selected.includes(deck[index + 26]) || matched.includes(deck[index + 26].uId) ? deck[index + 26].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="4.5rem" :class="[matched.includes(deck[index + 26].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 9" v-slot:default='{ hover }'>
              <td style="height: 4.5rem; width: 4rem;" @click="select(deck[index + 35])">
                <v-img :src="selected.includes(deck[index + 35]) || matched.includes(deck[index + 35].uId) ? deck[index + 35].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="4.5rem" :class="[matched.includes(deck[index + 35].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 9" v-slot:default='{ hover }'>
              <td style="height: 4.5rem; width: 4rem;" @click="select(deck[index + 44])">
                <v-img :src="selected.includes(deck[index + 44]) || matched.includes(deck[index + 44].uId) ? deck[index + 44].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="4.5rem" :class="[matched.includes(deck[index + 44].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 9" v-slot:default='{ hover }'>
              <td style="height: 4.5rem; width: 4rem;" @click="select(deck[index + 53])">
                <v-img :src="selected.includes(deck[index + 53]) || matched.includes(deck[index + 53].uId) ? deck[index + 53].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="4.5rem" :class="[matched.includes(deck[index + 53].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
          <tr>
            <v-hover v-for="index in 9" v-slot:default='{ hover }'>
              <td style="height: 4.5rem; width: 4rem;" @click="select(deck[index + 62])">
                <v-img :src="selected.includes(deck[index + 62]) || matched.includes(deck[index + 62].uId) ? deck[index + 62].image : 'https://i.imgur.com/xV7k72g.jpg'" width="4rem" height="4.5rem" :class="[matched.includes(deck[index + 62].uId) ? notSelectedClass : '']">
                </v-img>
              </td>
            </v-hover>
          </tr>
        </table>
    </v-col>
    <v-col cols="6">
      <h1>Chastity Time: {{computedChastityTime}}</h1>
      <h3 v-if="level == 0">Hopefully you aren't struggling, this is practice!</h3>
      <h3 v-if="level == 1">Now you're playing the easy round!</h3>
      <h3 v-if="level == 2">If you're having trouble now, you're going to hate the next round!</h3>
      <h3 v-if="level == 3">Last round! This is when it all really starts adding up!</h3>
      <h4>Last Matched Image</h4>
      <v-img :src="lastMatchedImage" height='25rem' contain></v-img>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'chastityMemory',
    data: () => ({
      cards: [
      "https://i.imgur.com/6v4ZUQV.jpg",
      "https://i.imgur.com/xjHMb4K.jpg",
      "https://i.imgur.com/Fkku091.jpg",
      "https://i.imgur.com/uMSxE6I.jpg",
      "https://i.imgur.com/e0LKJne.jpg",
      "https://i.imgur.com/rgLOUCy.jpg",
      "https://i.imgur.com/dzEHRBz.jpg",
      "https://i.imgur.com/uuWUTbQ.jpg",
      "https://i.imgur.com/pMacfq3.jpg",
      "https://i.imgur.com/cSMJPqD.jpg",
      "https://i.imgur.com/YHFMnpO.jpg",
      "https://i.imgur.com/IMyIPha.jpg",
      "https://i.imgur.com/EBJoG9m.jpg",
      "https://i.imgur.com/1548I0o.jpg",
      "https://i.imgur.com/LiiF7YK.jpg",
      "https://i.imgur.com/qww3P4K.jpg",
      "https://i.imgur.com/nrHhMPB.jpg",
      "https://i.imgur.com/gKSruvC.jpg",
      "https://i.imgur.com/KvCVLVe.jpg",
      "https://i.imgur.com/xiRd2xs.jpg",
      "https://i.imgur.com/2WqflyF.jpg",
      "https://i.imgur.com/hCChxVk.jpg",
      "https://i.imgur.com/h4hy6nt.jpg",
      "https://i.imgur.com/ij0BKUB.jpg",
      "https://i.imgur.com/msoFfuo.jpg",
      "https://i.imgur.com/ixMsU8p.jpg",
      "https://i.imgur.com/TWq8fDw.jpg",
      "https://i.imgur.com/TJgMJyJ.jpg",
      "https://i.imgur.com/OFC5A49.jpg",
      "https://i.imgur.com/JMOcfOw.jpg",
      "https://i.imgur.com/CeUivTC.jpg",
      "https://i.imgur.com/y4X2WSd.jpg",
      "https://i.imgur.com/UfL8Kuv.jpg",
      "https://i.imgur.com/VNDZJxA.jpg",
      "https://i.imgur.com/ieRtwRK.jpg",
      "https://i.imgur.com/xt8Bf32.jpg",
      "https://i.imgur.com/yvIOmZA.jpg",
      "https://i.imgur.com/1qmUCym.jpg",
      "https://i.imgur.com/ML6Slv7.jpg",
      "https://i.imgur.com/d7JagPm.jpg",
      "https://i.imgur.com/Wnb6988.jpg",
      "https://i.imgur.com/1utDElo.jpg",
      "https://i.imgur.com/HsYzvMR.jpg",
      "https://i.imgur.com/71kQMNd.jpg",
      "https://i.imgur.com/vSNmKfp.jpg",
      "https://i.imgur.com/RB9s0Tm.jpg",
      "https://i.imgur.com/K8zfosj.jpg",
      "https://i.imgur.com/r19Y5Mh.jpg",
      "https://i.imgur.com/NbqR3Ru.jpg",
      "https://i.imgur.com/p5etjBS.jpg",
      "https://i.imgur.com/Z45MdRn.jpg",
      "https://i.imgur.com/SApBE1M.jpg",
      "https://i.imgur.com/zoQzPbX.jpg",
      "https://i.imgur.com/MccIPCg.jpg",
      "https://i.imgur.com/gqMgGTy.jpg",
      "https://i.imgur.com/dmwVJ3L.jpg",
      "https://i.imgur.com/Nu8Fydw.jpg",
      ],
      notSelectedClass: 'notSelectedCSS',
      deck: [],
      selected: [],
      matched: [],
      level: 0,
      chastityTime: 60
    }),
    methods: {
      shuffle(array){
        var currentIndex = array.length, temporaryValue, randomIndex;

        while (0 !== currentIndex) {
      
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
      
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
      
        return array;
      },
      buildDeck(array){
        let objArr = new Array();
        for(var i = 0; i < array.length; i++){
          let tempObj = {
            id: i,
            image: array[i]
          };
          objArr.push(tempObj)
        }
        let newArr = objArr.concat(JSON.parse(JSON.stringify(objArr)));
        newArr.forEach(element => {
          element.uId = this.create_UUID()
        });
        return newArr;
      },
      create_UUID(){
        var dt = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (dt + Math.random()*16)%16 | 0;
            dt = Math.floor(dt/16);
            return (c=='x' ? r :(r&0x3|0x8)).toString(16);
        });
        return uuid;
    },
      select(card){
        if(!this.selected.includes(card) && !this.matched.includes(card.uId)){
          if(this.selected.length == 2){
            this.selected = [];
            this.chastityTime += (Math.floor(Math.random() * 30) + 1)
          }
          this.selected.push(card);
        }
        if(this.selected.length == 2){
          if(this.selected[0].id == this.selected[1].id){
            console.log("WE HAVE A MATCH");
            this.matched.push(this.selected[0].uId);
            this.matched.push(this.selected[1].uId);
            this.selected = [];
            if(this.level == 0){
              if(this.matched.length == 12){
                this.matched = [];
                this.selected = [];
                this.deck = this.shuffle(this.shuffle(this.buildDeck(this.shuffle(this.cards).slice(0,12))));
                this.level++;
              }
            }
            if(this.level == 1){
              if(this.matched.length == 24){
                this.matched = [];
                this.selected = [];
                this.deck = this.shuffle(this.shuffle(this.buildDeck(this.shuffle(this.cards).slice(0,24))));
                this.level++;
              }
            }
            if(this.level == 2){
              if(this.matched.length == 48){
                this.matched = [];
                this.selected = [];
                this.deck = this.shuffle(this.shuffle(this.buildDeck(this.shuffle(this.cards).slice(0,36))));
                this.level++;
              }
            }
          }
        }
      }
    },
    beforeMount(){
      this.deck = this.shuffle(this.shuffle(this.buildDeck(this.shuffle(this.cards).slice(0,6))));
    },
    computed:{
      computedChastityTime: function(){ 
        var hours = Math.floor(this.chastityTime / 60);  
        var minutes = this.chastityTime % 60;
        var string = '';
        if(hours){
          var string = hours + ' hour(s) and ' + minutes + ' minutes';
        } else {
          var string = minutes + 'minutes'
        }
        return string;
      },
      lastMatchedImage: function(){
        if(this.matched.length >= 2){
          return this.deck.find(card => card.uId == this.matched[this.matched.length - 1]).image;
        }
      }
    }
  }
</script>

<style>
    .notSelectedCSS {
      -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
      filter: grayscale(100%);
    }
  
    .v-card--reveal {
      align-items: center;
      bottom: 0;
      justify-content: center;
      opacity: .5;
      position: absolute;
      width: 100%;
    }
  </style>